import React from 'react';
import { motion } from 'framer-motion';
export function ForAgencies() {
  return <section className="py-24 border-b border-stone-300" data-id="element-944">
      <div className="max-w-6xl mx-auto px-6" data-id="element-945">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-946">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-947">
            {/* Left: Benefits grid */}
            <div className="order-2 lg:order-1" data-id="element-948">
              <div className="grid grid-cols-2 border border-stone-300" data-id="element-949">
                <div className="p-6 border-r border-b border-stone-300" data-id="element-950">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-951">
                    01
                  </p>
                  <p className="font-medium text-stone-900 mb-2" data-id="element-952">
                    Instant Options
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-953">
                    Good/Better/Best packages in seconds
                  </p>
                </div>

                <div className="p-6 border-b border-stone-300" data-id="element-954">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-955">
                    02
                  </p>
                  <p className="font-medium text-stone-900 mb-2" data-id="element-956">
                    Faster Approvals
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-957">
                    Real-time availability, no waiting
                  </p>
                </div>

                <div className="p-6 border-r border-stone-300" data-id="element-958">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-959">
                    03
                  </p>
                  <p className="font-medium text-stone-900 mb-2" data-id="element-960">
                    Track Everything
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-961">
                    Holds, deadlines, deposits in one place
                  </p>
                </div>

                <div className="p-6" data-id="element-962">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-963">
                    04
                  </p>
                  <p className="font-medium text-stone-900 mb-2" data-id="element-964">Win More</p>
                  <p className="text-sm text-stone-600" data-id="element-965">
                    Less back-and-forth, higher win rate
                  </p>
                </div>
              </div>
            </div>

            {/* Right: Content */}
            <div className="order-1 lg:order-2" data-id="element-966">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-967">
                For Agencies
              </p>

              <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-900 mb-8" data-id="element-968">
                Close groups faster
              </h2>

              <p className="text-lg text-stone-600 leading-relaxed mb-8" data-id="element-969">
                Agencies are the lifeblood of group travel. BlockQuote gives
                them the tools to present options instantly, secure inventory,
                and win more business for their clients.
              </p>

              <ul className="space-y-4 text-stone-600" data-id="element-970">
                <li className="flex items-start gap-3" data-id="element-971">
                  <span className="w-1 h-1 bg-red-600 mt-2.5 flex-shrink-0" data-id="element-972"></span>
                  <span data-id="element-973">No more waiting days for an email reply</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-974">
                  <span className="w-1 h-1 bg-stone-400 mt-2.5 flex-shrink-0" data-id="element-975"></span>
                  <span data-id="element-976">Professional, branded proposals ready to forward</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-977">
                  <span className="w-1 h-1 bg-stone-400 mt-2.5 flex-shrink-0" data-id="element-978"></span>
                  <span data-id="element-979">
                    Clear visibility into hold expiries and deposit dates
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}